require('../settings');
require('./assets/bootstrap');

import Vue from 'vue'
window.Vue = Vue;

import './pollyfills'
import VueRouter from 'vue-router'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import App from './App.vue'


import Ls from 'assets/services/ls'
window.Ls = Ls;

import swal from 'sweetalert2'
window.swal = swal;

import Webservice from 'assets/services/webservice'
window.Webservice = Webservice;

import General from 'assets/services/general'
window.General = General;

import Underscore from 'underscore';
window._ = Underscore;

window.SocketService = require('assets/services/socket');

Webservice.setSettings();

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'

// router setup
import routes from './routes/routes'

/*** Accounting Script for formatting money amounts ***/
window.accounting = require('accounting');

/** MomentJS Library */
window.moment = require('moment-timezone');

// Filters
require('./filters');


// library imports
import './assets/sass/paper-dashboard.scss'
import './assets/sass/element_variables.scss'
import './assets/sass/demo.scss'
import {ServerTable} from 'vue-tables-2';
import sidebarLinks from './sidebarLinks'

// plugin setup
Vue.use(VueRouter)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(VeeValidate);
locale.use(lang)
Vue.use(ServerTable, {});


VeeValidate.Validator.extend('verify_password', {
  getMessage: field => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character (E.g. , . _ & ? etc)`,
  validate: value => {
      var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})");
      return strongRegex.test(value);
  }
});

/**
 * Interceptors
 */
axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  if(localStorage.access_key){
      config.headers.common['Authorization'] = `Bearer ${localStorage.access_key}`;
  }
  return config;
}, function (error) {
  // Do something with request error
  router.push({name : 'Login'});
  return Promise.reject(error);
});

// configure router
const router = new VueRouter({
  linkActiveClass: 'active',
  mode: 'history',
  routes,
})


router.beforeEach((to, from, next) => {
  // If the next route is requires user to be Logged IN
  if (to.matched.some(m => m.meta.requiresAuth)){
      return Webservice.check().then(authenticated => {
          if(!authenticated){
            swal({
              title:
                "Session expired",
              buttonsStyling: false,
              icon: 'warning',
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: 'Re-login',
              html:
                "Sorry, your session expired. You need to login again."
            }).then((result) => {
              if (result) {
                router.push({name : 'Logout'});
              }
            });
            return;
          }
          return next()
      })
  } else {
    return next()
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router, Webservice
})





// WEBPACK FOOTER //
// ./src/main.js